import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { FileUploadModule } from 'ng2-file-upload';

import { PessoaTermoLGPDFileUploadComponent } from './pessoa-termo-lgpd-file-upload.component';

@NgModule({
    imports: [
        SharedModule,
        FileUploadModule
    ],
    declarations: [
        PessoaTermoLGPDFileUploadComponent
    ],
    exports: [
        PessoaTermoLGPDFileUploadComponent
    ]
})
export class PessoaTermoLGPDFileUploadModule { }
